import { Box } from "@mui/material";

export default function Column({ sx, ...props }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", ...sx }} {...props} />
  );
}
